import {
  ApiResponse,
  TokenData,
  DiscountType,
  DiscountMode,
  CreateApplyDiscount,
  IDiscountType,
  CreateApplyOtherDiscount,
} from '../models';
import * as http from './http';
import ApiService from './service';
import { LeadConfiguration } from '../models/configuration';

export class OtherDiscountTypeService extends ApiService {
  public async loadDiscountType() {
    const url = `${this.apiDomain}/api/discount/type/other`;

    const resposne = await http.get<ApiResponse<DiscountType[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async loadAllDiscountType() {
    const url = `${this.apiDomain}/api/discount/type/other`;

    const resposne = await http.get<ApiResponse<IDiscountType[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async getDiscountType(id?: string) {
    const url = `${this.apiDomain}/api/discount/type/other/${id}`;

    const response = await http.get<ApiResponse<TokenData>>(url, this.store);
    return response.data;
  }
  public async updateDiscountType(data: DiscountType, id?: string) {
    const url = `${this.apiDomain}/api/discount/type/other/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async createDiscountType(data: DiscountType) {
    const url = `${this.apiDomain}/api/discount/type/other`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteDiscountType(id?: string) {
    const url = `${this.apiDomain}/api/discount/type/other/${id}`;

    const response = await http.remove<ApiResponse<DiscountType>>(
      url,
      this.store
    );
    return response.data;
  }

  // Other discount

  async applyOtherDiscount(data: CreateApplyOtherDiscount, configId: string) {
    const url = `${this.apiDomain}/api/configuration/${configId}/other-discount`;
    const response = await http.post<ApiResponse<LeadConfiguration>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  async approveOtherDiscount(
    data: CreateApplyOtherDiscount,
    configId: string,
    discountId: string
  ) {
    const url = `${this.apiDomain}/api/configuration/${configId}/other-discount/${discountId}/approve`;
    const response = await http.put<ApiResponse<LeadConfiguration>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  async rejectOtherDiscount(
    data: CreateApplyOtherDiscount,
    configId: string,
    discountId: string
  ) {
    const url = `${this.apiDomain}/api/configuration/${configId}/other-discount/${discountId}/reject`;
    const response = await http.put<ApiResponse<LeadConfiguration>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  async deleteOtherDiscount(
    configId: string,
    type: string,
    discountId: string
  ) {
    const url = `${this.apiDomain}/api/configuration/${configId}/other-discount/${discountId}`;
    const response = await http.remove<ApiResponse<LeadConfiguration>>(
      url,
      this.store
    );
    return response.data;
  }

  async activateOtherDiscount(
    data: CreateApplyOtherDiscount,
    configId: string,
    discountId: string
  ) {
    const url = `${this.apiDomain}/api/configuration/${configId}/other-discount/${discountId}/activate`;
    const response = await http.put<ApiResponse<LeadConfiguration>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  async deactivateOtherDiscount(
    data: CreateApplyOtherDiscount,
    configId: string,
    discountId: string
  ) {
    const url = `${this.apiDomain}/api/configuration/${configId}/other-discount/${discountId}/deactivate`;
    const response = await http.put<ApiResponse<LeadConfiguration>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async updateonModelVariants(
    modelVariants: { modelCode: string; variantCode: string }[],
    id?: string
  ) {
    const url = `${this.apiDomain}/api/discount/type/other/${id}/model-variants`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      { modelVariants },
      this.store
    );
    return response.data;
  }
}
